export default class Application {
  id!: number;

  // eslint-disable-next-line camelcase
  display_name!: string;

  description!: string;

  // idUserOwner!: number; deprecated

  config!: string;

  thumbnail = null;

  tags=[];

  // eslint-disable-next-line camelcase
  public_access = false;

  highlight = false;

  usergroup!: number;
  // property to set and save access List
  access: any[] = [];
  // property to retrieve access List at map load
  'map_access': any[] = [];

  constructor(input?: unknown) {
    console.log(input);
    if (input) {
      Object.assign(this, input);
    }
  }

  setTumbnail(blob:any) :void{
    this.thumbnail = blob;
  }
}
